<template>
  <div class="login-box">
    <div class="loginBackGround">
      <div style="margin-left: 5%;margin-top: 10%;width: 45%">
        <div class="topLeftCorner">CORPORATE CULTURE</div>
        <div class="leftCenterCorner">作为科技使命：为普惠养老提供高品质的智能护理平台！</div>
        <img class="imagePat" src="../../../static/img/zuowei_pat.png" />
        <img class="loginCorner" src="../../../static/img/logo_zuowei_login.png" />
      </div>
      <div style="width: 45%;margin-right: 5%;margin-top: 7%" >
        <div style="display: flex;justify-content: space-between;margin-bottom: 30px">
          <span style="font-weight: bold; color: white;font-size: 26px;margin-left: 15%">登录</span>
          <div style="width: 1px;height: 22px;background: #E7EBF2;opacity: 1;margin-top: 9px"></div>
          <span style="color: white;font-size: 20px;margin-right: 15%;margin-top: 5px">护理后台管理系统</span>
        </div>
        <div class="formItemClass">
          <div class="formItemTitle">账号</div>
          <a-input class="inputClass" v-model="account" placeholder="请输入账号"/>
        </div>
        <div class="formItemClass">
          <div class="formItemTitle">密码</div>
          <a-input type="password" class="inputClass" v-model="password" placeholder="请输入密码"/>
        </div>
        <div class="formItemClass">
          <div class="formItemTitle">验证码</div>
          <div class="inputClass"  style="display: flex;align-items: center">
          <a-input class="inputClass" v-model="code" placeholder="请输入验证码"/>
            <a-button class="btnGetCode" type="link" :loading="getCodeLoading" :disabled="second>0" @click="getCode">{{second>0?second+"s":"获取验证码"}} </a-button>
          </div>
        </div>
        <a-button @click="login" type="primary" class="loginButton" :loading="loginLoading">登录</a-button>
        <div style="height: 60px;margin-left: 5%;margin-top: 20px">
          <div style="display: flex;align-items: center;">

            <a-radio :checked="protocol" @click="chooseProtocol"></a-radio>
            <div style="color:#FFF;font-size:13px">阅读并同意</div>
            <div class="privacy-item clickable" @click="showPrivacy('service')">《服务条款》</div>
            <div class="privacy-item clickable" @click="showPrivacy('law')">《法律声明》</div>
            <div class="privacy-item clickable" @click="showPrivacy('privacy')">《隐私政策》</div>
          </div>
        </div>
        <div style="margin-left: 5%;display: flex;align-items: center;">
          <div style="color: #728EB1"> © 2020 ZUOWEI 深圳作为科技有限公司 版权所有</div>
        </div>
      </div>
    </div>
    <Pointwave :color="0x0084FF"></Pointwave>

    <zuo-wei-privacy ref="privacy"></zuo-wei-privacy>

  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import Pointwave from '../../components/login/Pointwave'
import ZuoWeiPrivacy from "./ZuoWeiPrivacy"

export default {
  name: 'LoginNew',
  components: {
    Pointwave,ZuoWeiPrivacy
  },
  data () {
    return {
      account: '',
      password: '',
      code: '',
      getCodeLoading:false,
      second:0,
      protocol: false,
      loginLoading:false
    }
  },
  created() {
    // TODO 调试时，直接写入账号密码
    return
    this.account = "admin"
    this.password = "Zw20200320."
    this.code = "1024"
    this.protocol=true
  },
  methods: {
    chooseProtocol () {
      this.protocol = !this.protocol
    },
    getCode(){
      if(this.account.length === 0){
        this.$message.error("请输入账号");
        return
      }

      if(this.password.length === 0){
        this.$message.error("请输入密码");
        return
      }

      this.getCodeLoading=true
      this.$post('getCode', {
        username: this.account,
        password: this.password
      }).then(suc=>{
        this.getCodeLoading=false
        this.$message.success("已将验证码发到您的手机和邮箱");
        this.startCountDown()
      }).catch(err=>{
        this.getCodeLoading=false
      })
    },
    startCountDown(){
      this.second=60
      let countInterval = setInterval(()=>{
        this.second--
        if(this.second<=0){
          this.second=0
          clearInterval(countInterval)
        }
      },1000)
    },
    async login () {

      if(this.account.length === 0){
        this.$message.error("请输入账号");
        return
      }

      if(this.password.length === 0){
        this.$message.error("请输入密码");
        return
      }

      if(this.code.length === 0){
        this.$message.error("请输入验证码");
        return
      }

      if(!this.protocol){
        this.$message.error("请阅读并同意相关协议");
        return
      }

      this.loginLoading=true

      this.$post('loginWithCode', {
        username: this.account,
        password: this.password,
        code: this.code
      }).then((r) => {
        this.loginLoading=false
        let data = r.data
        this.saveLoginData(data)
        console.log('saveLoginData')
        // this.$router.push('/home')
        this.$router.push('/welcome')
        console.log('goto home')
      }).catch((e) => {
        this.loginLoading=false
      })
    },

    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setVendor: 'account/setVendor',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor'
    }),
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.expireTime)
      this.setUser(data.user)
      this.setVendor(data.vendor)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)


      // this.setTheme(data.config.theme)
      // this.setLayout(data.config.layout)
      // this.setMultipage(data.config.multiPage === '1')
      // this.fixSiderbar(data.config.fixSiderbar === '1')
      // this.fixHeader(data.config.fixHeader === '1')
      // this.setColor(data.config.color)
    },
    showPrivacy(type){
      this.$refs.privacy.show(type)
    }
  }
}
</script>

<style scoped>
.login-box {
  width: 100%;
  height: 100%;
  position: relative;
  background: #031029;
  background:linear-gradient(180deg,rgba(8,41,90,1) 0%,rgba(5,21,43,1) 100%);
}
  .loginBackGround {
    background: rgba(60,79,132,0.9);
    background-size: 100% 100%;
    width: 800px;
    height: 520px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 13;
    transform: translate(-50%,-50%);
    box-shadow: 0 39px 99px #031029;
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
  }
  .loginCorner {

    position: absolute;
    width: 120px;
    height: 30px;
    bottom: 5%;
  }
  .topLeftCorner {
    font-size: 30px;
    font-weight: normal;
    font-family: Helvetica Neue LT Pro;
    color: white;
    opacity: 0.5;
    line-height: 32px;
    width: 188px;
    height: 68px;
  }
  .leftCenterCorner {
    width:310px;
    height:48px;
    font-size:14px;
    line-height:26px;
    color:rgba(255,255,255,1);
  }
  .formItemClass {
    height: 75px;
    margin-left: 5%;
  }

  .formItemTitle{
    color: white;
    margin-bottom: 3px
  }

  .inputClass {
    width: 320px;
    height: 40px;
    border-radius: 10px;
    /*outline: none;*/
    /*padding-left: 20px;*/
  }
  .loginButton {
    border-radius: 10px;
    width: 320px;
    height: 40px;
    /*outline: none;*/
    margin-left: 5%;
    margin-top: 10px;
    /*background-color: #0084FF;*/
    /*color: white;*/
    /*cursor: pointer;*/
  }

  .btnGetCode{
    width: 140px;
    margin-left: -140px;
    border-left: 1px solid #EEE;
    z-index: 10;
    text-align: center;
    padding: 5px;
    margin-top: 2px;
  }


  .imagePat{
    width:120px;
    height: auto;
    position: absolute;
    margin-top: 20px;
  }

  .privacy-item{
    cursor: pointer;
    color:#0084FF;
    font-size: 13px;
  }

.clickable:hover{
  opacity: 0.7;
}

</style>



// WEBPACK FOOTER //
// src/views/login/LoginNursingRobot.vue